/**
 * Разделитель «или» между формой и кнопками OAuth.
 *
 * Был скопирован посимвольно в LoginPage и SignupPage — вместе с двумя
 * хардкодными цветами (#E8EBF1 линия, #60646A текст), которые не менялись
 * вместе с темой. Дубль из шести строк, но именно такие и расходятся:
 * поправишь отступ в одном месте — второе останется прежним.
 */
import React from "react";
import "./OAuthDivider.css";

export default function OAuthDivider({ label = "или" }) {
  return (
    <div className="rb-oauth-div" role="separator" aria-label={label}>
      <span className="rb-oauth-div__line" />
      <span className="rb-oauth-div__label">{label}</span>
      <span className="rb-oauth-div__line" />
    </div>
  );
}
